import { render, staticRenderFns } from "./OrcidAuthors.vue?vue&type=template&id=203755ab&scoped=true&"
import script from "./OrcidAuthors.vue?vue&type=script&lang=js&"
export * from "./OrcidAuthors.vue?vue&type=script&lang=js&"
import style0 from "./OrcidAuthors.vue?vue&type=style&index=0&id=203755ab&lang=scss&scoped=true&"
import style1 from "./OrcidAuthors.vue?vue&type=style&index=1&id=203755ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203755ab",
  null
  
)

export default component.exports